<div
  #track
  class="rec-slider__track"
  role="slider"
  tabindex="0"
  [attr.aria-label]="label() || null"
  [attr.aria-valuemin]="min()"
  [attr.aria-valuemax]="max()"
  [attr.aria-valuenow]="value()"
  [attr.aria-valuetext]="valueText()"
  [attr.aria-disabled]="disabled() ? 'true' : null"
>
  <div class="rec-slider__fill" [style.width.%]="fillPct()"></div>
  <div class="rec-slider__thumb" [style.left.%]="fillPct()"></div>
</div>
